<!--
~ Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
~
~ The information and source code contained herein is the exclusive property of
~ Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
~ or in part without the explicit written authorization from Anvilor Solutions LLC.
-->

@if (!!control && !!currentDisplay$) {
<div class="states-wrap">
  @if ((currentDisplay$ | async) === 'main') { @if (control.mainControl$ | async; as c) {
  <nvl-rui-rui-control @mainFade [internalId]="c.iid"></nvl-rui-rui-control>
  } } @if ((currentDisplay$ | async) === 'post_submit') { @if (control.postSubmitControl$ | async; as c) {
  <nvl-rui-rui-control @successFade [internalId]="c.iid"></nvl-rui-rui-control>
  } } @if ((currentDisplay$ | async) === 'pre_open') { @if (control.preOpenControl$ | async; as c) {
  <nvl-rui-rui-control [internalId]="c.iid"></nvl-rui-rui-control>
  } } @if ((currentDisplay$ | async) === 'post_close') { @if (control.postCloseControl$ | async; as c) {
  <nvl-rui-rui-control [internalId]="c.iid"></nvl-rui-rui-control>
  } }
</div>
}
